class ComparisonSliderComponent extends HTMLElement {
  connectedCallback() {
    this.mediaWrapper = this.querySelector("[data-comparison-slider]");
    this.slider = this.querySelector(".comparison-slider-input");
    this.isDragging = false;

    if (!this.mediaWrapper || !this.slider) return;

    this.sync();
    this.slider.addEventListener("input", this.sync);
    this.mediaWrapper.addEventListener("pointerdown", this.onPointerDown);
    this.mediaWrapper.addEventListener("pointermove", this.onPointerMove);
    this.mediaWrapper.addEventListener("pointerup", this.onPointerUp);
    this.mediaWrapper.addEventListener("pointercancel", this.onPointerUp);
  }

  disconnectedCallback() {
    this.slider?.removeEventListener("input", this.sync);
    this.mediaWrapper?.removeEventListener("pointerdown", this.onPointerDown);
    this.mediaWrapper?.removeEventListener("pointermove", this.onPointerMove);
    this.mediaWrapper?.removeEventListener("pointerup", this.onPointerUp);
    this.mediaWrapper?.removeEventListener("pointercancel", this.onPointerUp);
  }

  sync = () => {
    const min = Number(this.slider.min || 0);
    const max = Number(this.slider.max || 100);
    const value = Number(this.slider.value || 50);
    const compare = ((value - min) / (max - min)) * 100;

    this.mediaWrapper.style.setProperty("--compare", String(Math.round(compare)));
  };

  onPointerDown = (event) => {
    this.isDragging = true;
    this.mediaWrapper.setPointerCapture(event.pointerId);
    this.updateFromPointer(event);
  };

  onPointerMove = (event) => {
    if (!this.isDragging) return;

    this.updateFromPointer(event);
  };

  onPointerUp = (event) => {
    this.isDragging = false;

    if (this.mediaWrapper.hasPointerCapture(event.pointerId)) {
      this.mediaWrapper.releasePointerCapture(event.pointerId);
    }
  };

  updateFromPointer(event) {
    event.preventDefault();

    const rect = this.mediaWrapper.getBoundingClientRect();
    const orientation = this.mediaWrapper.dataset.orientation || "horizontal";
    let percent;

    if (orientation === "vertical") {
      const y = Math.min(Math.max(event.clientY, rect.top), rect.bottom);
      percent = 100 - ((y - rect.top) / rect.height) * 100;
    } else {
      const x = Math.min(Math.max(event.clientX, rect.left), rect.right);
      percent = ((x - rect.left) / rect.width) * 100;
    }

    this.slider.value = String(Math.round(percent));
    this.sync();
  }
}

if (!customElements.get("comparison-slider-component")) {
  customElements.define("comparison-slider-component", ComparisonSliderComponent);
}
